import { useQuery } from 'react-query';

import { Config } from '@ge/shared/data-hooks';

import * as inspectionServices from '../services/inspections';

export const useDefectTree = ({ inspectionType, staleTime = 10 * 60 * 1000 }) => {
  const {
    data = null,
    error,
    isLoading,
  } = useQuery(
    ['useDefectTree', inspectionType],
    async () => {
      if (inspectionType === null || inspectionType === undefined) {
        return null;
      }
      const result = await inspectionServices.getDamageTree(inspectionType, {});
      return result;
    },
    { ...Config.EXECUTE_ONCE, staleTime },
  );
  return {
    data,
    error,
    isLoading,
  };
};
